import { useDoorStore } from '../stores/doorStore.js';
import { useProducts } from './catalogue.js';
import { evaluateMeasurements, type CatalogueState } from './measurements.js';

export function useMeasurementsReadiness() {
  const draft = useDoorStore((state) => state.draft);
  const products = useProducts();
  let catalogue: CatalogueState;
  if (products.isPaused) {
    catalogue = { status: 'offline' };
  } else if (products.isFetching || products.isPending) {
    catalogue = { status: 'loading' };
  } else if (products.isError || !products.data) {
    catalogue = { status: 'error' };
  } else {
    // Cache age permits a refetch; it does not invalidate successfully checked rows.
    catalogue = { status: 'ready', rows: products.data };
  }

  return {
    draft,
    evaluation: evaluateMeasurements(draft, catalogue),
    catalogue,
    products: catalogue.status === 'ready' ? products.data : undefined,
    retry: () => void products.refetch(),
  };
}
